module.exports = __webpack_public_path__ + "static/img/zync_code.974ed7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/zync_code.png
// module id = ppfB
// module chunks = 11